import Image from "next/image";
import { ModuleColumn } from "@/components/module";

import img from "@/img/product/suppliers.png";

export default function SuppliersModule() {
  return (
    <ModuleColumn
      graphic={
        <Image
          src={img}
          alt="Illustration of factory with complex array of infrastructure"
          placeholder="blur"
        />
      }
      headline="Go deep on suppliers"
      className="module-suppliers"
    >
      <p>
        Most carbon is in the supply chain, and it’s been a black box for too
        long. Watershed helps you track carbon down to every supplier. Move from
        industry averages to fine-grained calculations for specific vendors, and
        work with them to cut emissions.
      </p>
      <style jsx global>{`
        section.module-suppliers {
          background-color: hsl(142deg 8% 80%);
          --section-link: #fff;
        }
        section.module-suppliers .padded-box {
          background-image: linear-gradient(
            hsl(142deg 8% 90%),
            hsl(142deg 8% 80%)
          );
          padding-bottom: 16px !important;
        }
        .module-suppliers h3 {
          color: hsl(142deg 8% 20%);
        }
        .module-suppliers p {
          color: hsl(142deg 8% 30%);
        }
      `}</style>
    </ModuleColumn>
  );
}
